import { useColorScheme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from 'react-router';
import DashboardHeader from '../components/layout/DashboardHeader';
import { useCallback, useRef, useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default function MainLayout() {
  const theme = useTheme();

  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const preferredMode = prefersDarkMode ? 'dark' : 'light';

  const { mode } = useColorScheme();

  const paletteMode = (!mode || mode === 'system') ? preferredMode : mode;

  const [isDesktopNavigationExpanded, setIsDesktopNavigationExpanded] =
    useState(true);

  const [isMobileNavigationExpanded, setIsMobileNavigationExpanded] =
    useState(false);

  const isOverMdViewport = useMediaQuery(theme.breakpoints.up('md'));

  const isNavigationExpanded = isOverMdViewport
    ? isDesktopNavigationExpanded
    : isMobileNavigationExpanded;

  const setIsNavigationExpanded = useCallback(
    (newExpanded: boolean) => {
      if (isOverMdViewport) {
        setIsDesktopNavigationExpanded(newExpanded);
      } else {
        setIsMobileNavigationExpanded(newExpanded);
      }
    },
    [
      isOverMdViewport,
      setIsDesktopNavigationExpanded,
      setIsMobileNavigationExpanded,
    ],
  );

  const handleToggleHeaderMenu = useCallback(
    (isExpanded: boolean) => {
      setIsNavigationExpanded(isExpanded);
    },
    [setIsNavigationExpanded],
  );

  const layoutRef = useRef<HTMLDivElement>(null);

  const logo = paletteMode === 'dark' ?
    <img src="/rinns_pantry_logo_dark.png" alt="Rinn's Pantry" /> :
    <img src="/rinns_pantry_logo.png" alt="Rinn's Pantry" />;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LeXqsAsAAAAAGThlPXMkSdVg8rTbsoUYESzssv3"
      useEnterprise
      container={{
        parameters: {
          theme: paletteMode === 'dark' ? 'dark' : 'light'
        }
      }}>
      <Box
        ref={layoutRef}
        sx={{
          position: 'relative',
          display: 'flex',
          overflow: 'hidden',
          height: '100%',
          width: '100%',
        }}
      >
        <DashboardHeader
          logo={logo}
          title=""
          menuOpen={isNavigationExpanded}
          showMenuIcon={false}
          onToggleMenu={handleToggleHeaderMenu}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0,
          }}
        >
          <Toolbar sx={{ displayPrint: 'none' }} />
          <Box
            component="main"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              overflow: 'auto',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </GoogleReCaptchaProvider>
  );
}
